import { AbstractControl, ValidatorFn } from '@angular/forms';

export const forbiddenCharacters = [
  '\\',
  '/',
  ':',
  '*',
  '?',
  '"',
  '<',
  '>',
  '|',
  'é',
  'Ĕ',
  'ë',
  'ö',
  'ò',
];

export const defaultAllowedFileTypes: string[] = [
  'doc',
  'docx',
  'xls',
  'xlsx',
  'pdf',
  'ppt',
  'pptx',
  'msg',
  'htm',
  'html',
  'pub',
  'pubx',
  'png',
  'bmp',
  'tif',
  'gif',
  'jpeg',
  'jpg',
  'avi',
  'm4v',
  'mov',
  'mp3',
  'wav',
  'wma',
  'mp4',
  'mpg',
  'mpeg',
  'swf',
  'wmv',
  'rtf',
  'tiff',
  'txt',
];

const allowedFileTypes = defaultAllowedFileTypes
  .map((type: string) => `.${type}`)
  .join(', ');

/**
 * Returns a mapping of file-name related validation error messages.
 * @param fieldName - The name of the field to be used in the error message.
 */
export const fileNameValidationErrorTextMap = (fieldName: string = 'Field') => {
  return {
    required: `${fieldName} is required.`,
    trailingPeriod: `${fieldName} cannot end with a period.`,
    invalidName: `${fieldName} must be between 1 and 255 characters`,
    forbiddenCharacters: `${fieldName} cannot include any of the following characters: ${forbiddenCharacters}`,
    invalidFileType: `${fieldName} valid file types: ${allowedFileTypes}`,
  };
};

export function fileTypeValidator(
  allowedTypes: string[] = defaultAllowedFileTypes,
): ValidatorFn {
  return (control: AbstractControl): { [key: string]: boolean } | null => {
    const file = control.value;

    if (file) {
      const extension = file.name.split('.').pop().toLowerCase();
      if (!allowedTypes.includes(extension)) {
        return { invalidFileType: true };
      }
    }

    return null;
  };
}

export function forbiddenCharactersValidator(): ValidatorFn {
  return (control: AbstractControl): { [key: string]: boolean } | null => {
    const file = control.value;
    if (file) {
      // Normalize the filename to ensure consistent character representation
      const fileName = file.name.normalize('NFC');
      // Convert each character in filename to its character code and check against forbidden codes
      for (let i = 0; i < fileName.length; i++) {
        const charCode = fileName.charCodeAt(i);
        if (
          forbiddenCharacters.some(
            (forbidden) =>
              forbidden.normalize('NFC').charCodeAt(0) === charCode,
          )
        ) {
          return { forbiddenCharacters: true };
        }
      }
    }
    return null;
  };
}
